module.exports = __webpack_public_path__ + "img/10-9.c20a23d3.png";